<ion-content class="ion-no-padding">
  <div class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">
          <span>Add Vehicle</span>
        </ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <!-- <ion-button class="filled-blue-btn" (click)="onSubmit(true)" [disabled]="!formDataModified()">
            Save & New
          </ion-button> -->
          <ion-button class="filled-blue-btn" type="submit" (click)="onSubmit()"
            [disabled]="!formDataModified()">Save</ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <div class="model-content">
      <div class="dashed-line"></div>
      <div class="form-container">
        <form [formGroup]="transferDetailsForm" *ngIf="transferDetailsForm">
          <div class="invoice-form-container">

            <!-- Room and Pricing -->
            <div>
              <div class="ion-no-padding">
                <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between">
                  <ion-title class="dark-title-sm ion-no-padding">Vehicle Details</ion-title>
                  <div>
                    <div class="currency-container">
                      <label class="label">Currency
                        <!-- TODO: use lov here -->
                        <select class="input" formControlName="currency">
                          <option *ngFor="let item of currencyLov" [value]="item.key">{{item.name}}</option>
                        </select>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dashed-line mt-2"></div>
              <div class="form-containesr ion-padding-horizontal">
                <div class="row">
                  <div class="col-4">
                    <div class="input-container">
                      <label for class="label">Vendor Company name*</label>
                      <div
                        [ngClass]="{ 'invalid-input': transferDetailsForm.get('vendorName')?.invalid && transferDetailsForm.get('vendorName')?.touched }">
                        <input type="text" class="input" placeholder="Vendor Name" formControlName="vendorName" />
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="input-container">
                      <div
                        [ngClass]="{ 'invalid-input': transferDetailsForm.get('firstName')?.invalid && transferDetailsForm.get('firstName')?.touched }">
                        <label for class="label">First Name*</label>
                        <input type="text" class="input" placeholder="First Name" formControlName="firstName" />
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="input-container">
                      <label for class="label">Last Name</label>
                      <div>
                        <input type="text" class="input" placeholder="Last Name" formControlName="lastName" />
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="input-container">
                      <label for class="label">Phone Number*</label>
                      <div
                        [ngClass]="{ 'invalid-input': transferDetailsForm.get('phoneNumber')?.invalid && transferDetailsForm.get('phoneNumber')?.touched }">
                        <app-phone-country-input formControlName="phoneNumber"></app-phone-country-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="input-container">
                      <label for class="label">Contact Email*</label>
                      <div
                        [ngClass]="{ 'invalid-input': transferDetailsForm.get('contactEmail')?.invalid && transferDetailsForm.get('contactEmail')?.touched }">
                        <input class="input input-text" placeholder="Email Address" formControlName="contactEmail" />
                      </div>
                    </div>

                  </div>
                  <div class="col-4">
                    <div class="input-container">
                      <label for="state" class="label">Serving Locations*</label>
                      <div
                        [ngClass]="{ 'invalid-input': transferDetailsForm.get('locations')?.invalid && transferDetailsForm.get('locations')?.touched }">
                        <app-multi-select-locations formControlName="locations" [googleLocations]="true"
                          [dropdownItems]="listOfPatchedLocations"
                          [placeHolder]="'-- select locations --'"></app-multi-select-locations>
                      </div>
                    </div>

                  </div>

                </div>
              </div>


            </div>

            <div>
              <ng-container formArrayName="vehicleDetails">
                <ng-container>
                  <div class="form-containesr ion-padding-horizontal toggle-visibility">
                    <!-- Pricing Table -->
                    <div class="mt-1 package-main-container">
                      <div class="package-title-container">
                        <div class="d-flex justify-content-between align-items-center">
                          <!-- Title or additional buttons can go here if needed -->
                        </div>
                      </div>

                      <!-- Package Table Container -->
                      <div class="pricing-table-container">
                        <table class="pricing-table pax-table">
                          <thead>
                            <tr>
                              <th rowspan="2" style="width: 90px;">Number of Seats</th>
                              <th rowspan="2" style="width: 90px;">Vehicle Type</th>
                              <th rowspan="2" style="width: 90px;">Transfer Mode</th>
                              <th rowspan="2" style="width: 90px;">Vehicle Name</th>
                              <th rowspan="2" style="width: 90px;">
                                Pricing({{transferDetailsForm.get('currency')?.value}})</th>
                              <th colspan="2">Price Validity</th>
                              <th rowspan="2" style="width: 90px;">Upload Vehicle Image</th>
                              <th rowspan="2" style="width: 50px;"></th>
                            </tr>
                            <tr>
                              <!-- Price Validity -->
                              <th style="width: 120px;">Start Date</th>
                              <th style="width: 120px;">End Date</th>
                            </tr>
                          </thead>
                          <tbody>

                            <tr *ngFor="let vehicle of vehicleDetails?.controls; let index = index"
                              [formGroupName]="index">
                              <!-- No of seats -->
                              <td>
                                <div class="input-container">
                                  <div
                                    [ngClass]="{ 'invalid-input': vehicle?.get('numberOfSeats')?.invalid && vehicle.get('numberOfSeats')?.touched }">
                                    <app-increment-number-input formControlName="numberOfSeats"
                                      [max]="100"></app-increment-number-input>
                                  </div>
                                </div>
                              </td>

                              <!-- Vehicle Type -->

                              <td>
                                <div class="input-container">
                                  <div
                                    [ngClass]="{ 'invalid-input': vehicle?.get('vehicleType')?.invalid && vehicle.get('vehicleType')?.touched }">
                                    <select name="" id="" class="input" formControlName="vehicleType">
                                      <option value="" hidden>--select type--</option>
                                      <option *ngFor="let item of vehicleTypeValues" [value]="item.key">{{item.name}}
                                      </option>
                                    </select>
                                  </div>

                                </div>
                              </td>

                              <!-- Transfer Mode -->
                              <td>
                                <div class="input-container">
                                  <div
                                    [ngClass]="{ 'invalid-input': vehicle?.get('TransferMode')?.invalid && vehicle.get('TransferMode')?.touched }">
                                    <app-dropdown-select [dropdownValues]="transferModeValues"
                                      formControlName="TransferMode"></app-dropdown-select>

                                  </div>
                                </div>

                              </td>

                              <!-- Vehicle Name -->
                              <td>
                                <div class="input-container">
                                  <div
                                    [ngClass]="{ 'invalid-input': vehicle.get('vehicleName')?.invalid && vehicle.get('vehicleName')?.touched }">
                                    <app-dropdown-select [dropdownValues]="vehicleNameValues"
                                      formControlName="vehicleName"></app-dropdown-select>
                                  </div>
                                </div>
                              </td>

                              <!-- Pricing -->
                              <td>
                                <div class="input-container">
                                  <div
                                    [ngClass]="{ 'invalid-input': vehicle?.get('pricing')?.invalid && vehicle.get('pricing')?.touched }">
                                    <input type="number" class="input" placeholder="USD" formControlName="pricing" />
                                  </div>
                                </div>
                              </td>

                              <!-- Price Validity -->
                              <td>
                                <ng-container formGroupName="priceValidity">
                                  <div class="input-container">
                                    <div
                                      [ngClass]="{ 'invalid-input': vehicle.get('priceValidity.startDate')?.invalid && vehicle.get('priceValidity.startDate')?.touched }">
                                      <app-date-picker formControlName="startDate"
                                        [maxDate]="vehicle.get('priceValidity.endDate')?.value"></app-date-picker>
                                    </div>
                                  </div>
                                </ng-container>
                              </td>
                              <td>
                                <ng-container formGroupName="priceValidity">
                                  <div class="input-container">
                                    <div
                                      [ngClass]="{ 'invalid-input': vehicle.get('priceValidity.endDate')?.invalid && vehicle.get('priceValidity.endDate')?.touched }">
                                      <app-date-picker formControlName="endDate"
                                        [minDate]="vehicle.get('priceValidity.startDate')?.value"></app-date-picker>
                                    </div>
                                  </div>
                                </ng-container>
                              </td>



                              <!-- Image Path -->
                              <td>
                                <input #fileinput type="file" accept=".png, .jpg, .jpeg, .pdf" hidden
                                  (change)="onFileSelected($event, index)" />
                                <ion-button *ngIf="!vehicle.get('imageDoc')?.value" class="filled-blue-btn"
                                  (click)="fileinput.click()">Upload</ion-button>
                                <div *ngIf="vehicle.get('imageDoc')?.value" class="file-actions">
                                  <p class="clickable-files" (click)="openAttachedFile(vehicle.get('imageDoc')?.value)">
                                    View
                                  </p>
                                  <ion-button *ngIf="vehicle.get('imageDoc')?.value" class="sm-clear-btn" fill="clear"
                                    size="small" color="danger" (click)="removeTransfersImage(index)">
                                    <ion-icon name="close-outline"></ion-icon> Clear
                                  </ion-button>
                                </div>
                              </td>

                              <td>
                                <ion-button fill="clear" color="danger" (click)="removeVehicle(index)"
                                  [disabled]="vehicleDetails.length <= 1">
                                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                                </ion-button>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <!-- room & Pricing -->
                  <div class="d-flex justify-content-end">
                    <!-- Add Room & Pricing Button -->
                    <ion-button class="sm-clear-btn" fill="clear" size="small" (click)="addVehicle()">
                      <ion-icon name="add-outline"></ion-icon> Add Vehicle
                    </ion-button>


                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div class="dashed-line mt-2"></div>
            <!-- Notes -->
            <div class="itinerary-model-content">
              <div class="ion-no-padding mb-1">
                <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Notes </ion-title>
              </div>

              <div class="form-container ion-padding-horizontal">
                <div class="row">
                  <div class="col">
                    <div class="input-container">
                      <app-text-formatting-input formControlName="notes"></app-text-formatting-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dashed-line"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ion-content>